/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import HeadsetMicOutlinedIcon from '@material-ui/icons/HeadsetMicOutlined';
import { moduleBrokerName } from '../module-params';

const useStyles = makeStyles((theme) => ({
  root: {
    '&.topBar': {
      width: 90,
      display: 'none',

      [theme.breakpoints.up('md')]: {
        display: 'block',
        marginRight: 6,
      },

      '& .button': {
        fontSize: '0.85rem',
      },
    },

    '&.drawer': {
      width: '100%',
      maxWidth: 133,
      display: 'block',

      [theme.breakpoints.up('md')]: {
        display: 'none',
      },

      '& .button': {
        height: 40,
      },
    },

    '& .button': {
      cursor: 'pointer',
      fontSize: '0.9rem',
      fontWeight: 500,
      color: 'var(--color-colorPrimary-main)',
      backgroundColor: 'var(--color-backgroundColors-hoverRowAlt)',
      height: 35,
      width: '100%',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      border: '1px solid',
      borderColor: 'var(--color-colorPrimary-main)',
      borderRadius: 3,
      margin: 0,
      textDecoration: 'none',

      '& svg': {
        fontSize: '20px',
        marginRight: 8,
      },
    },
  },
}));

function useSupportLink() {
  let hrefLink = 'https://quantiply.tech/contact/';

  if (moduleBrokerName === 'upstox') {
    hrefLink = '/general/customer-support';
  }

  return hrefLink;
}

const SupportButton = ({ className = '', topBar = false, drawer = false }) => {
  const classes = useStyles();
  const supportLink = useSupportLink();

  return (
    <div
      className={`${classes.root} ${className} ${topBar ? 'topBar' : ''} ${
        drawer ? 'drawer' : ''
      }`}
    >
      <a className="button" href={supportLink} target="_blank">
        <HeadsetMicOutlinedIcon />
        Support
      </a>
    </div>
  );
};

export default SupportButton;
